import { DanceEvent, ExternalEvent, PageDataTypeCMSEvent } from "src/types";
import CMS from ".";
import { RouteComponentProps } from "src/declaration";
import { RenderEvent } from "../../components/dance_event";
import { Timestamp } from "firebase/firestore";

export default function CMSEvents(props: RouteComponentProps) {
  const pageData = props.innerHTML as PageDataTypeCMSEvent;
  const events = pageData.CMSEvents;
  const innerHTML = pageData.body;

  const _renderEvent = (event: DanceEvent | ExternalEvent) => {
    event.start = new Timestamp(event.start.seconds, event.start.nanoseconds);
    if (event.end) {
      event.end = new Timestamp(event.end.seconds, event.end.nanoseconds);
    }
    return (
      <div>
        <RenderEvent event={event} />
        <br />
      </div>
    );
  };

  const internalEvents = () => {
    if (events?.internal?.length) {
      return (
        <div>
          <h3 style={{ textAlign: "center" }}>Upcoming CMJA Events</h3>
          {events.internal.map(_renderEvent)}
        </div>
      );
    }
    return;
  };
  const externalEvents = () => {
    if (events?.external?.length) {
      const externalEvents = events.external.filter(
        (externalEvent) =>
          (externalEvent.end || externalEvent.start).seconds * 1000 > Date.now()
      );
      return (
        <div>
          <h3 style={{ textAlign: "center" }}>Other Events</h3>
          <div>
            <strong>Note: </strong>These events are run by other companies, here
            or interstate.
            <br />
            We can tell you more about what many of the events are like, but you
            will need to book with them.
          </div>
          <br />
          {externalEvents.map(_renderEvent)}
          <br />
        </div>
      );
    }
    return;
  };

  const pastEvents = () => {
    if (events?.past?.length) {
      return (
        <div>
          <h3 style={{ textAlign: "center" }}>Recent CMJA Events</h3>
          {events.past.map(_renderEvent)}
        </div>
      );
    }
    return;
  };

  const externalLinks = () => {
    const extLinks = {
      "https://cerocevents.co.nz/": "Ceroc NZ events",
      "https://fevah.dance/events/":
        "Event list of another NZ modern jive school",
      "https://cerocasia.com/": "Ceroc Pan Asia Championships",
      "https://modernjive.com/":
        "UK-centric, but also includes a lot of links. Note that some are quite out of date",
      "https://www.ceroc.com/":
        "Ceroc UK (with some franchises in other countries, and some of their events move around)",
    };
    return (
      <div>
        If you're interested in travelling further for events, you may also be
        interested in:
        <ul>
          {Object.entries(extLinks).map(([url, description]) => (
            <li>
              <a href={url} title={description}>
                {url}
              </a>{" "}
              - {description}
            </li>
          ))}
        </ul>
      </div>
    );
  };

  const subProps = { ...props, innerHTML } as unknown as RouteComponentProps;

  return (
    <>
      <CMS {...subProps} />
      <div id="events"></div>
      {internalEvents()}
      {pastEvents()}
      {externalEvents()}
      {externalLinks()}
    </>
  );
}
